import "./style.css";
import MiddleSection from "./brand-middle-section";
import style from './brand-module.module.scss';
import { Helmet } from 'react-helmet';
import { useEffect } from "react";
import { useLocation } from "react-router-dom"; 


const BrandComponent = () => {

  const location = useLocation(); 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
     <Helmet>
    <title>MeMate Brand Assets | Logos, Guidelines & Media Kit</title>
    <meta name="description" content="Download official MeMate logos, colours, and branding guidelines. Access our media kit for press, partners, or promotional use. Simple, approved, and up to date." />
    <meta property="og:title" content="MeMate Brand Assets | Logos, Guidelines & Media Kit" />
      <meta property="og:description" content="Download official MeMate logos, colours, and branding guidelines. Access our media kit for press, partners, or promotional use. Simple, approved, and up to date." />
    </Helmet>
      <div className={`kb-main-section ${style.mainHeadinstyle}`}>
      {/* <h5>memate</h5> */}
      {/* <h1 className="h1tagsseo">meMate Brand </h1> */}
      <h2 className="latest-update-text latest-brandMain latest-update-head memate-brand headerPadding">
      brand <br></br>overview
      </h2>
      <h1 className="heading-text-blog">MeMate Brand Assets & Media Kit</h1>
      </div>
      <MiddleSection />
      <div>

      </div>
    </>
  );
};

export default BrandComponent;
